<div
  class="root"
  [ngClass]="{
    root_property1PrimaryCtaLargeDisable:
      property1 === 'Primary CTA_Large_Disable',
    root_property1PrimaryCtaLargeActive:
      property1 === 'Primary CTA_Large_Active',
    root_property1SecondaryCtaLargeActiveProperty1SecondaryCtaLargeDisable:
      property1 === 'Secondary CTA_Large_Active' ||
      property1 === 'Secondary CTA_Large_Disable',
    root_property1PrimaryCtaLargeDisableProperty1SecondaryCtaLargeActiveProperty1SecondaryCtaLargeDisable:
      property1 === 'Primary CTA_Large_Disable' ||
      property1 === 'Secondary CTA_Large_Active' ||
      property1 === 'Secondary CTA_Large_Disable',
    root_property1SecondaryCtaLargeActive:
      property1 === 'Secondary CTA_Large_Active',
    root_property1SecondaryCtaLargeDisable:
      property1 === 'Secondary CTA_Large_Disable'
  }"
>
  <div
    class="container"
    [ngClass]="{
      container_property1PrimaryCtaLargeDisableProperty1PrimaryCtaLargeActiveProperty1SecondaryCtaLargeDisable:
        property1 === 'Primary CTA_Large_Disable' ||
        property1 === 'Primary CTA_Large_Active' ||
        property1 === 'Secondary CTA_Large_Disable',
      container_property1SecondaryCtaLargeActive:
        property1 === 'Secondary CTA_Large_Active'
    }"
  >
    <span
      class="text"
      [ngClass]="{
        text_property1PrimaryCtaLargeDisableProperty1SecondaryCtaLargeDisable:
          property1 === 'Primary CTA_Large_Disable' ||
          property1 === 'Secondary CTA_Large_Disable',
        text_property1PrimaryCtaLargeActive:
          property1 === 'Primary CTA_Large_Active',
        text_property1SecondaryCtaLargeActive:
          property1 === 'Secondary CTA_Large_Active'
      }"
      >Upload Document</span
    >
  </div>
</div>
